import React from 'react';
import { UiSectionComponentName } from './Types/UiSection';
import { snakeCase } from 'lodash';
import {
  AutoFixHigh,
  Campaign,
  Email,
  Filter1,
  Folder,
  HistoryEdu,
  Lightbulb,
  Store,
  Warning,
} from '@mui/icons-material';

export const getSectionBackgroundColor = (theme: any, index: number) => {
  if (index % 2 === 0) {
    return 'transparent';
  }

  return index % 4 === 1 ? theme.palette.secondary.light : theme.palette.primary.light;
};

type SectionField =
  | 'title'
  | 'content'
  | 'alignment'
  | 'media'
  | 'banner'
  | 'cta_label'
  | 'cta_url'
  | 'communication_type'
  | 'counters';

export const sectionFields: Record<UiSectionComponentName, SectionField[]> = {
  anomalyForm: ['content', 'cta_label', 'cta_url'],
  customBlock: ['title', 'content', 'media', 'cta_label', 'cta_url', 'alignment'],
  demandForm: ['content'],
  featuredConsultations: ['title', 'content'],
  featuredNews: ['title', 'content', 'communication_type'],
  folders: ['title', 'content'],
  kpis: ['title', 'content', 'counters'],
  latestIdeas: ['title', 'content'],
  spaceInfo: ['title', 'content', 'banner', 'counters'],
};

export const sectionIcons: Record<UiSectionComponentName, React.ElementType> = {
  spaceInfo: Store,
  customBlock: AutoFixHigh,
  folders: Folder,
  featuredConsultations: Campaign,
  featuredNews: HistoryEdu,
  latestIdeas: Lightbulb,
  kpis: Filter1,
  demandForm: Email,
  anomalyForm: Warning,
};

export const uiSectionComponentTitleId = (componentName: UiSectionComponentName) => {
  return `UI_SECTION.FORM.ITEMS.${snakeCase(componentName).toUpperCase()}.TITLE`;
};
export const uiSectionComponentDescriptionId = (componentName: UiSectionComponentName) => {
  return `UI_SECTION.FORM.ITEMS.${snakeCase(componentName).toUpperCase()}.DESCRIPTION`;
};
